export const SET_TOUCH_STATE = 'SET_TOUCH_STATE';
export const TOGGLE_SIDEBAR_VISIBILITY_ON_MOBILE = 'TOGGLE_SIDEBAR_VISIBILITY_ON_MOBILE';
export const SET_DEVICE = 'SET_DEVICE';
